import axios, {
  ResponseData
} from './base.ts'
import {
  AxiosPromise
} from 'axios'
const url = ``

export function getList(data = {}) {
  return axios.request({
    url: `${url}/medias`,
    method: "get",
    params: data,
  })
}

export function getListSelect(data = {}) {
  return axios.request({
    url: `${url}/medias/select`,
    method: "get",
    params: data,
  })
}
export function getDataById(id,params={}){
  return axios.request({
    url: `${url}/media/${id}`,
    method: "get",
    params,
  })
}

export function deleteData(id,data) {
  return axios.request({
    url: `${url}/media/${id}`,
    method: "delete",
    params:data,
  })
}
export function addData(data) {
  return axios.request({
    url: `${url}/media`,
    method: "post",
    data: data,
  })
}
export function editData(id, data) {
  return axios.request({
    url: `${url}/media/${id}`,
    method: "put",
    data: data,
  })
}

export function apply(id, data) {
  return axios.request({
    url: `${url}/media/apply/${id}`,
    method: "put",
    data: data,
  })
}

export function refuse(id, data) {
  return axios.request({
    url: `${url}/media/refuse/{id}`,
    method: "put",
    data: data,
  })
}